import { leaguesImg } from "../static/img/leagues";

export const getSuperTimeIcon = (nome) => {
  let img = null;

  if (!nome) {
    return null;
  }

  if (nome.includes("Europa")) {
    img = leaguesImg.europa;
  }

  if (nome.includes("França")) {
    img = leaguesImg.franca;
  }

  if (nome.includes("Serie")) {
    img = leaguesImg.brasil;
  }

  if (nome.includes("Inglaterra")) {
    img = leaguesImg.inglaterra;
  }

  if (nome.includes("Itália")) {
    img = leaguesImg.italia;
  }

  if (nome.includes("Espanha")) {
    img = leaguesImg.espanha;
  }

  return img;
};



// WEBPACK FOOTER //
// ./src/utils/getSuperTimeIcon.js